export const SizeType = {
  ALL: 1,
  ONETIME_S_M: 2,
}

export const OPERATION_HOUR_START = 12
export const OPERATION_HOUR_END = 22
